import type { ReactNode } from "react";
import { Trash } from "lucide-react";
import { IconButton } from "../../../ui/IconButton";

export type GuardedDeleteProps = {
  label?: string;
  /** Why it can't be deleted ("Used by 3 products"), or null when it can */
  blockedReason: string | null;
  onDelete: () => void;
  icon?: ReactNode;
  size?: "sm" | "md";
};

/** A delete button that stays disabled, with the reason as its tooltip, while something still uses the row. */
export function GuardedDelete({ label = "Delete", blockedReason, onDelete, icon, size = "md" }: GuardedDeleteProps) {
  const glyph = icon ?? <Trash size={16} />;
  if (!blockedReason) return <IconButton label={label} variant="danger" size={size} icon={glyph} onClick={onDelete} />;
  // A disabled button gets no hover or focus: the wrapper carries the tooltip and takes keyboard focus.
  return (
    <span className="guarded-delete" data-tooltip={blockedReason} tabIndex={0}>
      <IconButton label={`${label} (${blockedReason})`} tooltip={false} variant="danger" size={size} icon={glyph} disabled />
    </span>
  );
}

export default GuardedDelete;
